import React  from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import {Col, Row, Form, Button, Spinner } from "react-bootstrap";
import FormComponent from './common/formComponent';

class SaleItemDetails extends FormComponent {
  state = {
    data: {},
    errors: {},
    loading: true,
    processing: false,
  };

  schema = {
    quantity: Joi.number()
      .required()
      .label("Quantity")
  };

  componentDidMount() {}

  doSubmit = async () => {
    this.setState({ processing: true });
    try {
      this.props.callBackFromParent(this.state.data);
    } catch (ex) {
      if (ex.response && (ex.response.status >= 400 && ex.response.status < 500)) {
        toast.error(ex.response.data);
      }
    }

    this.setState({ processing: false, data: { quantity: "" } });
  };

  render() {
    const { data, errors, processing } = this.state;
    const { item } = this.props;

    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="card mb-3">
          <div className="card-header">
            <i className="fas fa-table mr-2" />
            Quantity
          </div>
          <div className="card-body">
            {!item._id && <span className="small text-muted">No item seletected</span>}
            {item._id && (
              <React.Fragment>
                <Form.Group as={Row} controlId="quantity">
                  <Col sm={12}>
                    <Form.Control
                      name="quantity"
                      placeholder="Quantity"
                      onChange={this.handleChange}
                      value={data.quantity}
                      size="sm"
                      type="number"
                    />
                    {errors.quantity && <span className="text-danger">{errors.quantity}</span>}
                  </Col>
                </Form.Group>
              </React.Fragment>
            )}
          </div>
          <div className="card-footer">
          <Button type="submit" block disabled={this.validate() || processing}>
            {processing && (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            )}
            Next
          </Button>
          </div>
        </div>
      </Form>
    );
  }
}

export default SaleItemDetails;